// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'VAT Return Total VAT Amount Due',
    [LanguagesEnum.Greek]: 'VAT Return Total VAT Amount Due',
  },
  note: {
    [LanguagesEnum.English]:
      'Please Review your VAT Return Form and make sure that you have entered all the Correct and Required Infomration, before the final submission. The information provided must be correct and consistent from a mathematical point of view. Please check that the correct VAT Rate/Type has been selected, and that the Taxable Amount and the VAT Amount fields are correct for each supply that you have declared per Member State of Consumption.',
    [LanguagesEnum.Greek]:
      'Please Review your VAT Return Form and make sure that you have entered all the Correct and Required Infomration, before the final submission. The information provided must be correct and consistent from a mathematical point of view. Please check that the correct VAT Rate/Type has been selected, and that the Taxable Amount and the VAT Amount fields are correct for each supply that you have declared per Member State of Consumption.',
  },
  total_vat_amount_due: {
    [LanguagesEnum.English]: 'Total VAT Amount (€):',
    [LanguagesEnum.Greek]: 'Total VAT Amount (€):',
  },
  total_vat_amount_payable: {
    [LanguagesEnum.English]: 'Total VAT Amount Payable (€):',
    [LanguagesEnum.Greek]: 'Total VAT Amount Payable (€):',
  },
};

export default CONFIGURATION;
